import { changeDurationResponsesAction } from "./reducer";

export const changeDurationResponses = (preloader : any) => async (dispatch : any) => {
  try {
      dispatch(changeDurationResponsesAction(preloader));
  } catch (error) {
      // console.log(error);
  }
};